// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define responsive styles using media queries */
/* For screens up to 600px wide */
@media screen and (max-width: 600px) {
  .checklist-modal {
    width: 90%; 
  }
}

/* For screens between 601px and 1024px wide */
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .checklist-modal {
    width: 60%;
  }
}

/* For screens wider than 1024px */
@media screen and (min-width: 1025px) {
  .checklist-modal {
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Checklist/ChecklistModel.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD,iCAAiC;AACjC;EACE;IACE,UAAU;EACZ;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* Define responsive styles using media queries */\n/* For screens up to 600px wide */\n@media screen and (max-width: 600px) {\n  .checklist-modal {\n    width: 90%; \n  }\n}\n\n/* For screens between 601px and 1024px wide */\n@media screen and (min-width: 601px) and (max-width: 1024px) {\n  .checklist-modal {\n    width: 60%;\n  }\n}\n\n/* For screens wider than 1024px */\n@media screen and (min-width: 1025px) {\n  .checklist-modal {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
